import { styled } from '@/stitches.config';
import { Box, Button } from '@base-app';
import { ReactComponent as SuccesIcon } from '@assets/icons/success.svg';

import SequenceGoal from '../SequenceGoal';

export const StyledSequenceGoalCard = styled(Box, {
  display: 'flex',
  padding: '$7',
});

export const StyledSequenceGoal = styled(SequenceGoal, {
  display: 'flex',
});

export const StyledButton = styled(Button, {
  width: '130px',
});

export const StyledButtonContainer = styled(Box, {
  display: 'flex',
  justifyContent: 'center',
  margin: '$4 0 $6 0',
});

export const StyledSuccessIcon = styled(SuccesIcon, {
  color: '#7ACB71',
  height: '$10',
  width: '$10',
});
